import { Credibility } from '@chegg-wt/core/types/core'
import considerCredibility, { findPageCredibility } from '../copy/credibility'
import { seoContent } from '../copy/seo-content/index'

interface SeoCopy {
  considerCredibility?: Credibility
  seoContent?: string
}

const seoContents = {
  apa: seoContent.apaSeoContent,
  ama: seoContent.amaSeoContent,
  'american-medical-association': seoContent.americanMedicalAssociationSeoContent,
  chicago: seoContent.chicagoSeoContent,
  ieee: seoContent.ieeeSeoContent,
  mla: seoContent.mlaSeoContent,
}

const seoContentForSource = {
  chicago: {
    book: seoContent.chicagoBookSeoContent,
    website: seoContent.chicagoWebsiteSeocontent,
  },
}

export const getSeoCopy = (style: string): SeoCopy => {
  if (seoContents[style]) return { seoContent: seoContents[style] }
  return { considerCredibility }
}

export const getSeoCopyWithSource = (style: string, source: string): SeoCopy => {
  if (seoContentForSource[style] && seoContentForSource[style][source])
    return { seoContent: seoContentForSource[style][source] }
  return { considerCredibility: findPageCredibility }
}
